import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export const GAMES_FILTERS_STORAGE_KEY = 'orbitGamesFiltersData';

export class GamesFiltersStorage {
    constructor(private readonly services: IServiceFactoryExtended) {
        this._savedFilters = this.services.localStorage.getJson(GAMES_FILTERS_STORAGE_KEY) || {};
    }

    private _savedFilters: Record<string, string[]> = {};

    saveFiltersForCurrentArena(filterIds: string[]): void {
        const arenaType = this.services.routing.currentRoute.data?.arenaType;
        if(arenaType) {
            this._savedFilters[arenaType] = filterIds;
            this.services.localStorage.setJson(GAMES_FILTERS_STORAGE_KEY, this._savedFilters);
        }
    }

    clearAllSavedFilters(): void {
        this._savedFilters = {};
        this.services.localStorage.removeItem(GAMES_FILTERS_STORAGE_KEY);
    }

    getSavedFiltersForCurrentArena(): string[] {
        const arenaType = this.services.routing.currentRoute.data?.arenaType;
        if(arenaType) {
            return this._savedFilters[arenaType] ?? []
        }
        return [];
    }
}